module.exports = __webpack_public_path__ + "media/images/icon_list/user-35eb2efc016b5072ed42406d70f275d7.svg";